import React, { Component } from 'react';
import Highcharts from 'highcharts';
import { normalizeChartConfig } from '../../utils/highcharts-utils';

require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

export default class Chart extends Component {
  constructor(props) {
    super(props);

    this.chartNode = null;
    this.chartInstance = null;
  }

  componentDidMount() {
    const chartConfig = normalizeChartConfig(this.props.highcharts);
    const chart = new Highcharts.Chart(this.chartNode, chartConfig);
    chart.setSize(this.props.size[0], this.props.size[1], false);
    this.chartInstance = chart;

    if (this.props.registerInstance) {
      this.props.registerInstance(this.props.id, this.chartInstance);
    }

    // handle animate charts
    if (this.props.animate && this.props.animate.frames) {
      const frames = this.props.animate.frames;

      let delay = 0,
        prevDuration = 0;
      for (let i = 0; i < frames.length; i++) {
        const { data, duration } = frames[i];
        // "stack" the delay by the frame's duration and all previous frame durations
        delay += prevDuration;
        prevDuration = duration;
        (function (chart, data, duration, delay) {
          setTimeout(function () {
            for (let j in data) {
              chart.series[j].setData(data[j], true, {
                duration,
                easing: 'linear',
              });
            }
          }, delay);
        })(chart, data, duration, delay);
      }
    }
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      nextProps.size !== this.props.size ||
      nextProps.highcharts !== this.props.highcharts
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.highcharts !== this.props.highcharts) {
      this.chartInstance.update(normalizeChartConfig(this.props.highcharts));
    } else if (prevProps.size !== this.props.size) {
      this.chartInstance.setSize(this.props.size[0], this.props.size[1], false);
    }
  }

  render() {
    return <div ref={(c) => (this.chartNode = c)} />;
  }
}

Chart.defaultProps = {
  node: '',
  position: 'nw',
  dark: false,
  highcharts: {},
  animate: undefined,
};
